<template>
  <div class="container module">
    <page-header v-if="banner" type="image" :height="750" :image="banner">
      <template v-slot:searchbox>
        <div class="search-form">
          <div class="title">Module</div>
          <el-input class="search-input" placeholder="keywords"></el-input>
        </div>
      </template>
    </page-header>

    <div class="navi">
      <PageNavbar class="inn" />
    </div>

    <filters
      :showFilter="showFilter"
      :columns1="cats"
      columns1_title="Product Categories"
      :columns2="module_types"
      columns2_title="File Type"
      :total="total"
      @resetItems="resetItems"
      @searchItems="searchItems"
      @toggleStatus="toggleFilterFormStatus"
    >
    </filters>

    <div class="section-module">
      <ModuleList :items="items" />
    </div>

    <div class="section">
      <div class="loadmore" v-if="hasmore">
        <div class="btn" @click="loadMore">Load More</div>
      </div>
    </div>

    <page-footer />
  </div>
</template>
<style lang="scss" scoped>
.module {
  background-color: #fff;
}

.section-module {
  margin-left: 210px;
  margin-right: 210px;
}

.navi {
  position: relative;
  display: flex;
  justify-content: center;

  .inn {
    margin-top: -75px;
  }
}

.search-input {
  width: 350px;
}
</style>

<script>
import PageFooter from "../components/PageFooter.vue";
import PageHeader from "../components/PageHeaderV2.vue";
import PageNavbar from "../components/PageNavbar.vue";
import Filters from "../components/Filters.vue";
import ModuleList from "../components/ModuleList.vue";
import { mapGetters } from "vuex";
import Api from "../utils/api";

export default {
  name: "Module",
  components: {
    PageFooter,
    PageHeader,
    PageNavbar,
    Filters,
    ModuleList,
  },
  computed: {
    ...mapGetters({
      cats: "getProductCats",
      module_types: "getModuleTypes",
      getPageData: "getPageData",
    }),

    banner() {
      let key = "modules";
      let page = this.getPageData;
      return !!page[key] ? page[key] : false;
    },
  },
  methods: {
    toggleFilterFormStatus() {
      this.showFilter = !this.showFilter;
    },
    resetItems() {
      this.items = [];
      this.showFilter = false;
      this.getModuleList({ pg: 1 });
    },
    searchItems(args) {
      let options = {
        scene_cat: args["selected_col1"],
        module_type: args["selected_col2"],
        pg: 1,
      };
      this.showFilter = false;

      this.items = [];

      this.getModuleList(options);
    },
    loadMore() {
      if (this.hasmore) {
        let pg = this.pg + 1;
        this.getModuleList({ pg });
      }
    },
    getModuleList(args) {
      Api.getModuleList(args)
        .then((res) => {
          let items = this.items;
          this.items = items.concat(res.items);
          this.total = res.total;
          this.hasmore = res.hasmore;
          this.pg = Number(res.pg);
        })
        .catch((err) => {
          console.log("err", err);
        });
    },
  },
  created() {
    this.getModuleList({ pg: 1 });
  },

  data() {
    return {
      showFilter: false,
      brand: "",
      total: 0,
      pg: 1,
      hasmore: false,
      items: [],
    };
  },
};
</script>
